import styled from "@emotion/styled"
import { TbLoader2 } from "@react-icons/all-files/tb/TbLoader2"
import { GREEN_COLOR } from "theme/colors"
import Stack from "./Stack"

const SpinningLoader = styled(TbLoader2)`
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`

const Overlay = styled(Stack)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 1);
`

export function LoadingOverlay() {
  return (
    <Overlay justify="center" align="center">
      <SpinningLoader size={48} color={GREEN_COLOR} />
    </Overlay>
  )
}

const Container = styled(Stack)`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 100%;
  min-width: 100%;
  background-color: rgba(255, 255, 255, 1);
`

export default function LoadingContainer({
  children,
}: {
  children?: React.ReactNode
}) {
  return (
    <Container justify="center" align="center">
      <Stack gap="12px">
        <SpinningLoader size={48} color={GREEN_COLOR} />
        {children}
      </Stack>
    </Container>
  )
}
